import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { EmbeddedCheckout } from "@stripe/react-stripe-js";

export default function EmbeddedCheckoutWrapper({ clientSecret }) {
  return (
<Box
  w="100%"
  maxW="480px"
  mx="auto"
  borderRadius="md"
  py={6}
  bg="white"
>
  <EmbeddedCheckout clientSecret={clientSecret} />
</Box>

  );
}
